import React from 'react';
export function Activities() {
  const skills = ['Motricidad fina', 'Lenguaje', 'Coordinación', 'Atención', 'Resolución de problemas', 'Estimulación sensorial', 'Concentración', 'Creatividad', 'Aprendizaje natural'];
  return <section className="bg-brand-black text-white py-16 px-4 sm:px-6" data-id="element-19">
      <div className="max-w-3xl mx-auto text-center space-y-10" data-id="element-20">
        <div className="space-y-4" data-id="element-21">
          <span className="text-5xl block mb-4" data-id="element-22">🌱</span>
          <h2 className="font-archivo text-3xl sm:text-4xl uppercase" data-id="element-23">
            Actividades pensadas para acompañar:
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-24">
          {skills.map((skill, idx) => <div key={idx} className="bg-white/10 p-4 rounded-xl border border-white/20 flex items-center justify-center gap-2 font-bold text-lg" data-id="element-25">
              <span className="text-brand-green" data-id="element-26">✔</span> {skill}
            </div>)}
        </div>
      </div>
    </section>;
}